/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Format_LabelInputs */



/**
* | output |
* | --- |
* | "Subtitle Format" |
*
* @param {Iconik_Publish_Format_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_format_label = /** @type {((inputs?: Iconik_Publish_Format_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Format_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Format de sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitelformat")
	if (locale === "it") return /** @type {LocalizedString} */ ("Formato dei sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Формат субтитров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formato de subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕格式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕フォーマット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षक प्रारूप")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formato de legenda")
	return /** @type {LocalizedString} */ ("Subtitle Format")
});